import { render } from "./YouTube.vue?vue&type=template&id=f2c72af2&scoped=true&ts=true"
import script from "./YouTube.vue?vue&type=script&lang=ts"
export * from "./YouTube.vue?vue&type=script&lang=ts"

import "./YouTube.vue?vue&type=style&index=0&id=f2c72af2&lang=scss&scoped=true"
import "./YouTube.vue?vue&type=style&index=1&id=f2c72af2&lang=scss"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2c72af2"]])

export default __exports__